// Flow animation for map links: pure maths so it can be checked with bun.
// The SVG side is a dashed overlay line whose stroke-dashoffset is driven by
// one CSS keyframe (see .netmap-flow in styles/index.css) — no per-edge JS.

/** Dash period of the overlay (4 on, 12 off); the keyframe scrolls exactly one period. */
export const FLOW_PERIOD = 16;
/** 0 % utilisation crawls at 2.5 s per period; 100 % runs at 0.25 s. Linear in between. */
export const FLOW_SLOW_S = 2.5;
export const FLOW_FAST_S = 0.25;

/** Seconds per dash period for a utilisation; null/NaN/out-of-range clamp to the slow end. */
export function flowDuration(utilPct: number | null): number {
  const u = utilPct === null || Number.isNaN(utilPct) ? 0 : Math.min(100, Math.max(0, utilPct));
  return FLOW_FAST_S + (FLOW_SLOW_S - FLOW_FAST_S) * ((100 - u) / 100);
}

/**
 * Which way the dashes travel. rx/tx are measured at the SOURCE end, so tx at
 * source means traffic leaves source towards target ("forward"); rx at source
 * means the target is sending ("reverse"). Equal or missing rates: "none" —
 * the overlay drifts back and forth with no net direction.
 */
export function flowDirection(rxBps: number | null, txBps: number | null): "forward" | "reverse" | "none" {
  const rx = rxBps ?? 0, tx = txBps ?? 0;
  if (tx > rx) return "forward";
  if (rx > tx) return "reverse";
  return "none";
}
